import React, { useContext, useEffect, useState } from 'react'
import { CalculatorContext } from '../context'

const TableRows = ({ color, table, activeTable, activeRowCol, claritySort }) => {
  const { onCellClick, activeCell } = useContext(CalculatorContext)
  const [row, setRow] = useState([])
  const sortRows = (array, sortArray) => {
    return [...array].sort(
      (a, b) => sortArray.indexOf(a.clarity) - sortArray.indexOf(b.clarity)
    )
  }

  useEffect(() => {
    const data = sortRows(table.filter((item) => item.color === color), claritySort)
    if (data.length) {
      setRow(data)
    }
  }, [table, color])

  return (
    <tr key={color}>
      <td className={`price__table-cell price__table-cell--color  ${activeTable && activeRowCol.color === color ? 'price__table-cell--selected' : ''}`}>{color}</td>
      {row.filter((item) => item.isActive).map((item) => {
        return <td className={`price__table-cell ${activeTable && (item.clarity === activeRowCol.clarity || item.color === activeRowCol.color) ? 'price__table-cell--color' : ''} ${item.id === activeCell ? 'price__table-cell--selected' : ''}`} key={item.id} onClick={() => onCellClick(item)}>{item.price / 100}</td>
      })}
    </tr>
  )
}

export default TableRows
